import { render, staticRenderFns } from "./CAudio.vue?vue&type=template&id=eeb2c5f4&scoped=true&"
import script from "./CAudio.vue?vue&type=script&lang=ts&"
export * from "./CAudio.vue?vue&type=script&lang=ts&"
import style0 from "./CAudio.vue?vue&type=style&index=0&id=eeb2c5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb2c5f4",
  null
  
)

component.options.__file = "CAudio.vue"
export default component.exports